import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { GraduationCap, DollarSign, Map } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const Index = () => {
  const { user, userProfile } = useAuth();
  
  const sections = [
    {
      title: "First Day Guide",
      description: "Everything you need to know for your first day",
      icon: GraduationCap,
      link: "/wiki/onboarding/first-day"
    },
    {
      title: "Pay Structure",
      description: "Learn how you earn and maximize your income",
      icon: DollarSign,
      link: "/wiki/compensation/pay-incentives"
    },
    {
      title: "Route Map",
      description: "View service areas and coverage information",
      icon: Map,
      link: "/wiki/resources/route-coverage"
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      
      <main className="flex-1 pt-24">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-br from-primary/10 to-accent/10">
          <div className="container mx-auto px-4 text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 text-foreground">
              Welcome to BlueLux{user && userProfile?.first_name && `, ${userProfile.first_name}`}!
            </h1>
            <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
              Your complete resource for pool service excellence, compensation, and company policies.
            </p>
            <Button asChild size="lg" className="bg-primary hover:bg-primary/90">
              <Link to="/wiki/onboarding/welcome">Get Started</Link>
            </Button>
          </div>
        </section>

        {/* Sections Grid */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {sections.map((section) => {
                const Icon = section.icon;
                return (
                  <Card key={section.title} className="hover:shadow-lg transition-shadow">
                    <CardHeader>
                      <div className="flex items-center justify-center mb-4">
                        <Icon className="h-12 w-12 text-primary" />
                      </div>
                      <CardTitle className="text-center">{section.title}</CardTitle>
                      <CardDescription className="text-center">
                        {section.description}
                      </CardDescription>
                    </CardHeader>
                    <CardContent className="text-center">
                      <Button asChild variant="outline" className="w-full">
                        <Link to={section.link}>Explore</Link>
                      </Button>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Index;
